/// <amd-module name="Artifacts/Pypi/helpers/InstructionsHelper" />
import { IPackageVersion } from "Artifacts/Root/types";

export function getCopyInstallCommand(pkgName: string, pkgVersion: IPackageVersion): string {
  return `pip install ${pkgName}==${pkgVersion.version}`;
}
